import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";


/* ---------- Page Imports ------------ */
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, DesignationGet, employeeGet, employeeSalaryDetailsPost } from "../../../Api/Admin/AdminApi"
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const EmployeePayDetailsAdd = () => {
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingCompany, setLoadingCompany] = useState(true);
  const [employeeData, setEmployeeData] = useState([]);
  const [designationData, setdesignationData] = useState([]);
  const [selectedEmployeeDesignation, setSelectedEmployeeDesignation] = useState('')
  const [formData, setFormData] = useState({
    company_id: null,
    emp_id: '',
    design_id: null,
    Basic_Pay: null,
    Attendance_allowance: null,
    Overtime_pay: null,
    Standard_Gross: 0,
    allowences: null,
    incentives: null,
    CPF: null,
    advance: null,
    payment_mode: ''
  });

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingCompany(true)
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const fetchDesignation = async () => {
      try {
        const data = await DesignationGet();
        if (data) {
          const designation = data.map(i => ({
            id: i._id,
            name: i.name,
          }));
          setdesignationData(designation)
        } else {
          console.log('No Designation data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
    fetchDesignation();
  }, [])

  useEffect(() => {
    if (formData.emp_id && employeeData.length > 0) {
      const selectedEmployee = employeeData.find(emp => emp.emp_id === formData.emp_id);
      if (selectedEmployee) {
        setSelectedEmployeeDesignation(selectedEmployee.designation);
        const designation = designationData.find(d => d.name === selectedEmployee.designation);
        if (designation) {
          setFormData(prev => ({
            ...prev,
            design_id: designation.id
          }));
        }
      }
    }
  }, [formData.emp_id, employeeData, designationData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'company_id') {
      onEmployeedetails(value);
      setFormData(prev => ({
        ...prev,
        emp_id: '',
        design_id: null
      }));
      setSelectedEmployeeDesignation('');
    }
  }

  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          designation: i.designation
        }));
        setEmployeeData(emp);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Form Data:", formData);
      const response = await employeeSalaryDetailsPost(formData);
      if (response) {
        alert("Salary Details Added Successfully")
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title="Employee Salary Details" showButtons={true} />
        <h4>
          Add Employee Salary Details
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option>Select Organization</option>
                {organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Select Employee</Form.Label>
              <Form.Select
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option>Select Employee</option>
                {employeeData.map(empl => (
                  <option key={empl.emp_id} value={empl.emp_id}>{empl.emp_name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="design_id">
              <Form.Label>Employee Designation</Form.Label>
              <Form.Select
                name="design_id"
                value={formData.design_id}
                onChange={handleChange}
                required
                disabled
              >
                <option value="">{selectedEmployeeDesignation || 'Select Employee First'}</option>
                {formData.design_id && (
                  <option value={formData.design_id}>
                    {selectedEmployeeDesignation}
                  </option>
                )}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="Basic_Pay">
              <Form.Label>Basic Pay</Form.Label>
              <Form.Control
                type="number"
                name="Basic_Pay"
                value={formData.Basic_Pay}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Attendance_allowance">
              <Form.Label>Attendance Allowance</Form.Label>
              <Form.Control
                type="number"
                name="Attendance_allowance"
                value={formData.Attendance_allowance}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Overtime_pay">
              <Form.Label>Overtime Pay</Form.Label>
              <Form.Control
                type="number"
                name="Overtime_pay"
                value={formData.Overtime_pay}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="allowences">
              <Form.Label>Allowences</Form.Label>
              <Form.Control
                type="number"
                name="allowences"
                value={formData.allowences}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="incentives">
              <Form.Label>Incentives</Form.Label>
              <Form.Control
                type="number"
                name="incentives"
                value={formData.incentives}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="cpf">
              <Form.Label>CPF</Form.Label>
              <Form.Control
                type="number"
                name="CPF"
                value={formData.CPF}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group controlId="payment_mode">
              <Form.Label>Payment Method</Form.Label>
              <div className="d-flex align-items-center" style={{ height: '38px' }}>
                <Form.Check
                  inline
                  label="Bank"
                  type="radio"
                  name="payment_mode"
                  value="1"
                  checked={formData.payment_mode === '1'}
                  onChange={handleChange}
                  className="me-2"
                />
                <Form.Check
                  inline
                  label="Cash"
                  type="radio"
                  name="payment_mode"
                  value="0"
                  checked={formData.payment_mode === '0'}
                  onChange={handleChange}
                />
              </div>
            </Form.Group>
          </Row>
          <Row className="mb-4 justify-content-center">
            <Form.Group as={Col} md='4'>
              <Button type="submit" variant="primary" className="mt-3">
                Add Pay
              </Button>
            </Form.Group>
          </Row>
        </Form>
      </Container>
    </div>
  )
};

export default EmployeePayDetailsAdd;